import React from 'react';
import { useTheme, Stack, Typography, InputAdornment } from '@mui/material';
import InputTextField from '@components/InputTextField';

export default function InputWithLabel({
  type,
  label,
  startAdornment,
  ...otherProps
}) {
  const theme = useTheme();
  return (
    <Stack width="100%">
      <Typography
        sx={{
          pb: 1,
          pl: 1.875,
          fontSize: theme.fonts.sizes.font12PX,
          color: theme.colors.light.lightSteelBlue,
          fontWeight: theme.typography.fontWeightBold,
          fontFamily: theme.fonts.family.primary,
          textTransform: 'uppercase',
        }}
      >
        {label}
      </Typography>
      <InputTextField
        type={type}
        {...otherProps}
        sx={{
          ...(type === 'number' && {
            'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
              '-webkit-appearance': 'none',
              margin: 0,
            },
            'input[type=number]': {
              '-moz-appearance': 'textfield',
            },
          }),
        }}
        inputStyles={{
          fontSize: theme.fonts.sizes.font14PX,
          color: theme.colors.light.lightCyan,
          fontFamily: theme.fonts.family.primary,
          textTransform: 'capitalize',
        }}
        InputProps={{
          ...(startAdornment && {
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{
                  fontWeight: 'fontWeightRegular',
                  fontSize: theme.fonts.sizes.font16PX,
                  '& .MuiTypography-root': {
                    color: theme.colors.light.lightCyan,
                  },
                }}
              >
                {startAdornment}
              </InputAdornment>
            ),
          }),
          ...(type === 'number' && {
            type: 'number',
            min: 0,
          }),
        }}
      />
    </Stack>
  );
}

InputWithLabel.defaultProps = {
  type: 'text',
};
